import PaymentSettings from './payment-settings';

export default PaymentSettings;
